import PropTypes from "prop-types";
import PhotoShape from "./Photo";

const SpaceShape = PropTypes.shape({
  id: PropTypes.number,
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  venue_name: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  hasFlag: PropTypes.bool,
  addedFlag: PropTypes.string,
  photos: PropTypes.arrayOf(PhotoShape.isRequired).isRequired,
  contact_info: PropTypes.object,
  limit_lock: PropTypes.bool,
});

export default SpaceShape;
